import * as React from "react";

import CostForm from "../../../components/Forms/ManagementContract/CostForm/FlowForm";

export default () => {
  return <CostForm />;
};
